import { Component, OnInit, Inject, Optional } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MatDialogConfig,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MessageService } from 'src/app/common/services/message.service';
import { HeaderComponent } from 'src/app/common/header/header.component';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../common/services/common.service';
import { UtilService } from 'src/app/util/util.service';
import { ApiService } from 'src/app/common/services/api.service';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { ResponsiveService } from 'src/app/common/services/responsive.service';
import { TranslateService } from '@ngx-translate/core';
import { MAP, LUNCH, EDITOR_JSON, CROSS} from 'src/defaultImages.js';
import { LocalStorageService } from 'src/app/common/services/localStorage.service';
@Component({
  selector: 'app-order-type',
  templateUrl: './order-type.component.html',
  styleUrls: ['./order-type.component.css'],
})
export class OrderTypeComponent implements OnInit {
  images = {
    MAP: MAP,
    LUNCH: LUNCH,
    EDITOR_JSON: EDITOR_JSON,
    CROSS: CROSS
  };
  isGFOrderEnabled: boolean = false;
  isFPOrderEnabled: boolean = false;
  orderType = [];
  isKiosk;
  lengthChar: number;
  status: any;
  from: any;
  selectedOrderTypeId: number;
  customerForm: FormGroup;
  allSections = [];
  selectedSection: string;
  selectedFloorTables = [];
  currentTitle: string;
  translationText: any = {};
  modalState = {
    showOrderType: true,
    showCustomer: false,
    showTable: false,
  };
  selectedOrder = {
    id: null,
    name: '',
    platform: '',
    img: '',
    email: null,
  };
  isPlatformMenuSync: boolean = false;
  showAutoSync: boolean = false;
  options: AnimationOptions = {
    path: this.images.EDITOR_JSON,
  };
  currBothDLTKPlatform: any = {};
  numberChar;
  currBothDLTKPlatformActive: boolean = false;
  isFPOrderSynced: boolean = false;
  isGFOrderSynced: boolean = false;
  autoSync: boolean = false;
  validityStatus: string = '';
  message = {
    errorString: '',
    validityString: '',
    successString: '',
    warningString: '',
  };
  updatePassCodeNeeded: boolean = false;
  isFpIntegrationEnabled: boolean;
  isGfIntegrationEnabled: boolean;
  restid_code: string;
  fp_orderid: string = null;
  breakPoint: string;
  op_orderid: string = null;
  syncKey = '';
  restSettings;
  fpOrderApiLoading: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<HeaderComponent>,
    public dialog: MatDialog,
    private messageService: MessageService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private route: Router,
    private utilService: UtilService,
    private apiService: ApiService,
    private commonService: CommonService,
    private responsive: ResponsiveService,
    public translateService: TranslateService,
    public _localStorage: LocalStorageService
  ) {
    this.translateService.use(localStorage.getItem('language') || 'en_US');
    this.isKiosk = this.utilService.isKiosk();
  }

  ngOnInit() {
    this.translateService.get(['ORDER_DASHBOARD']).subscribe((translation) => {
      this.translationText = translation.ORDER_DASHBOARD || {};
    });
    this.responsive.mediaBreakpoint$.subscribe((value) => {
      this.breakPoint = value;
    });
    this.restSettings = JSON.parse(localStorage.getItem('restaurant_settings'));
    this.isGFOrderEnabled = this.restSettings['global']['gf_integration'] || 0;
    this.isFPOrderEnabled = this.restSettings['global']['fp_integration'] || 0;
    this.getOrderTypeListDetails();
    this.get_tables();
    this.checkFPOrderSynced('grab');
    this.checkFPOrderSynced('foodpanda');
    this.status = this.data.status;
    this.from = this.data.from;
    if (this.status.orderTypeShow == 1)
      this.currentTitle = this.translationText?.SELECT_ORDER_TYPE;
    this.customerForm = this.fb.group({
      name: ['', Validators.required],
      dial_code: [localStorage.getItem('pos_dial_code')],
      number: [''],
      user_gender: [localStorage.getItem('user_gender')],
      user_dob: [localStorage.getItem('user_dob')],
    });
  }
  checkFPOrderSynced(platform: string) {
    let type;
    if (platform === 'foodpanda') type = 'fp';
    else if (platform === 'grab') type = 'gf';
    this.apiService
      .isFoodPandaOrderSynced(localStorage.getItem('restaurant_id'), type)
      .subscribe((res: any) => {
        if (platform === 'foodpanda') {
          if (res.statusCode === 200) {
            if (res.data.fp_menu_sync === 1) this.isFPOrderSynced = true;
            else if (res.data.fp_menu_sync === 0) this.isFPOrderSynced = false;
          } else this.isFPOrderSynced = false;
        } else if (platform === 'grab') {
          if (res.statusCode === 200) {
            if (res.data.gf_menu_sync === 1) this.isGFOrderSynced = true;
            else if (res.data.gf_menu_sync === 0) this.isGFOrderSynced = false;
          } else this.isGFOrderSynced = false;
        }
      },(error)=>{
        console.error(error);
      });
  }
  getOrderTypeListDetails() {
    // const param = new FormData();
    // param.append("restaurant_id", localStorage.getItem("restaurant_id"));
    // this.apiService.getRestaurantDetails(param).subscribe(
    //   (res: any) => {
    //     if (res.status == 1) {
    //       const orderTypeList = this.utilService.prepareOrderTypeList(res.data.offline_platforms);
    //       this.orderType = this.utilService.get_pos_order_type(orderTypeList);
    //     }
    //   })
    this.commonService.getRestaurantDataObs().subscribe((data) => {
      const orderTypeList = this.utilService.prepareOrderTypeList(
        (data || {}).offline_platforms
      );
      this.orderType = this.utilService.get_pos_order_type(orderTypeList);
      try {
        for (let [i, item] of ((data || {}).offline_platforms || {}).entries()) {
          if ((item.id === 'foodpanda' || item.id === 'grab')) {
            item.id === 'foodpanda'
              ? (this.syncKey = 'isFPOrderSynced')
              : (this.syncKey = 'isGFOrderSynced');
            if (item['rest_id']) this.restid_code = item['rest_id'];
            if (item['sync'] === 1) {
              this[this.syncKey] = true;
            } else this[this.syncKey] = false;
          }
        }
      } catch {
        this[this.syncKey] = false;
      }
    });
  }
  cancel_clicked() {
    this.dialogRef.close({ data: 'closed' });
  }

  checkFpItemMapping(platform: string) {
    let type;
    if (platform === 'foodpanda') {
      type = 'fp';
    } else if (platform === 'grab') {
      type = 'gf';
    }
    this.apiService
      .getAllFoodpandaMapping(
        localStorage.getItem('restaurant_id'),
        '1',
        '1',
        type
      )
      .subscribe(
        (response) => {
          if (response.statusCode === 200) {
            if (
              response.data &&
              response.data.unmapped_items_count &&
              typeof response.data.unmapped_items_count === 'number'
            )
              this.openUnmappedModal(response.data);
          }
        },
        (error) => {
          this.messageService.showError(error.error.message);
        }
      );
  }

  async openUnmappedModal(unmapped_items) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    const { FpUnmappedComponent } = await import(
      /* webpackPrefetch: true */ 'src/app/order/modal/fp-unmapped/fp-unmapped.component'
    );
    const dialogRef = this.dialog.open(FpUnmappedComponent, {
      backdropClass: 'none',
      maxHeight: '90vh',
      data: {
        platform: this.selectedOrder.platform,
        unmapped_items,
      },
      maxWidth: '100vw',
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.message === 'do_it_later') {
        localStorage.setItem(
          'ee_fpMapping_later',
          localStorage.getItem('restaurant_id')
        );
        this.commonService.orderActionMessage({ action: 6 });
      }
      if (result && result.message === 'success') {
        localStorage.removeItem('ee_fpMapping_later');
      }
    });
  }
  orderTypeClicked(item) {
    // this.selectedOrderTypeId = item.id;
    this.selectedOrder.id = item.id;
    this.selectedOrder.name = item.name;
    this.selectedOrder.platform = item.platform;
    this.selectedOrder.img = item.img_src;
    item.email && (this.selectedOrder.email = item.email);
    this.currBothDLTKPlatformActive = item.order_type === 3;
    this.currentTitle = this.translationText.CUSTOMER_DETAILS;
    this.modalState.showOrderType = false;
    this.modalState.showCustomer = true;
    this.modalState.showTable = false;
    if (this.breakPoint !== 'xs') {
      this.isFpIntegrationEnabled = !!this.utilService.isFpIntegrationEnabled();
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      this.isGfIntegrationEnabled =
        (restSettings.global || {}).gf_integration || false;

      let fp_mapping_later = !!(
        localStorage.getItem('ee_fpMapping_later') ===
        localStorage.getItem('restaurant_id')
      );

      if (
        (this.isFpIntegrationEnabled &&
          item.platform === 'foodpanda' &&
          this.isFPOrderSynced) ||
        (this.isGfIntegrationEnabled &&
          item.platform === 'grab' &&
          this.isGFOrderSynced)
      ) {
        this.checkFpItemMapping(this.selectedOrder.platform);
      }
    }
    if (item.platform === 'foodpanda' && this.isFPOrderSynced) {
      this.isPlatformMenuSync = true;
      this.currentTitle = this.translationText.NEW_FOOD_PANDA_ORDER;
      // this.createFPOrders();
      // this.restid_code = this.restid_code1
    }

    if (item.platform === 'grab' && this.isGFOrderSynced) {
      this.isPlatformMenuSync = true;
      this.currentTitle = this.translationText.NEW_GRAB_ORDER;
      this.restid_code = 'GF';
      // this.createFPOrders();
    }
    if (
      (this.isGFOrderEnabled && item.platform === 'grab') ||
      (item.platform === 'foodpanda' && this.isFPOrderEnabled)
    ) {
      this.showAutoSync = true;
    } else this.showAutoSync = false;

    if (this.from === 'order' || this.from === 'tables-layout') {
      this.modalState.showCustomer = false;
      localStorage.setItem('pos_order_type_set', '1');
      localStorage.setItem('pos_user_details_set', '0');
      localStorage.setItem('pos_table_no_set', '0');

      if (!this.isPlatformMenuSync) {
        if (item.order_type === 3) {
          this.currentTitle = this.translationText?.SELECT_ORDER_TYPE;
          this.currBothDLTKPlatform = item;
          this.currBothDLTKPlatformActive = true;
        } else {
          this.exitModal('dl', 'dl');
        }
      } else {
        // this.currentTitle = "Select Order Type";
        if (item.order_type === 3) {
          this.currBothDLTKPlatform = item;
          this.currBothDLTKPlatformActive = true;
        }
      }
    }
  }

  setPlatformOrderTypeClicked(type) {
    if (type == 1) {
      this.selectedOrder.id = 1;
    } else {
      this.selectedOrder.id = 2;
    }
    this.exitModal('dl', 'dl');
  }

  exitModal(tableNo, tableId){
    if(this.selectedOrder.id === 2){
      tableNo = tableId = "takeaway";
    } 
    this.setPOSdatanExit(
      this.selectedOrder.id,
      this.selectedOrder.platform,
      this.customerForm.value.name,
      tableNo,
      tableId,
      this.customerForm.value.dial_code,
      this.customerForm.value.number,
      this.customerForm.value.user_gender,
      this.customerForm.value.user_dob
    );
    this.dialogRef.close();
  }

  onOrderIdChanges(e) {
    this.selectedOrder.platform === 'foodpanda'
      ? (this.lengthChar = 4)
      : (this.lengthChar = 3);
    this.validityStatus = 'warning';
    this.message.warningString =
      this.translationText.MUST_BE +
      this.lengthChar +
      this.translationText.OR_MORE_CHARACTERS;
    this.updatePassCodeNeeded = false;
    if (this.fp_orderid.split('').length >= this.lengthChar) {
      if(this.fpOrderApiLoading) return;
      this.validityStatus = 'validating';
      this.message.validityString =
        this.translationText.FETCHING_ORDER_DETAILS_FROM +
        this.selectedOrder.name;

      const payload = {
        restaurant_id: localStorage.getItem('restaurant_id'),
      };
      if (this.selectedOrder.platform === 'foodpanda') {
        let fp_order_id = this.restid_code.concat('-', this.fp_orderid);
        const arr = [];
        arr.push(fp_order_id);
        payload['fp_order_ids'] = arr;
      } else if (this.selectedOrder.platform === 'grab') {
        let fp_order_id = this.restid_code.concat('-', this.fp_orderid);
        const arr = [];
        arr.push(fp_order_id);
        payload['op_order_ids'] = arr;
      }

      let type;
      let apiInitiateCondition;
      if (this.selectedOrder.platform === 'foodpanda') {
        type = 'fp';
        apiInitiateCondition = [8,9,14].includes(payload['fp_order_ids'][0].length);
      } else if (this.selectedOrder.platform === 'grab') {
        type = 'gf';
        apiInitiateCondition = [6,7].includes(payload['op_order_ids'][0].length);
      }
      if(apiInitiateCondition) {
      this.fpOrderApiLoading = true;
      this.apiService.createFoodPandaOrders(payload, type).subscribe(
        (res: any) => {
          if (res.statusCode === 201) {
            if (res.data.orders_failed && res.data.orders_failed.length) {
              this.validityStatus = 'error';
              this.message.errorString = res.data.message;
              this.messageService.showError(res.data.message, 5000);
            } else {
              this.validityStatus = 'success';
              this.message.successString =
                this.translationText.ORDER_ID_CREATED_SUCCESSFULLY;
              localStorage.setItem(
                'redirect_pos_order_id',
                res.data.orders_created[0]
              );
              this.messageService.showSuccess(res.data.message);
              this.commonService.orderActionMessage({ action: 0 });
              setTimeout(() => {
                this.dialogRef.close({ data: 'closed' });
              }, 2000);
            }
          } else {
            this.messageService.showError(res.data.message);
          }
          this.fpOrderApiLoading = false;
        },
        (error) => {
          console.log(error);
          if (
            error.error.statusCode === 401 ||
            error.error.statusCode === 403
          ) {
            // this.validityStatus = 'error';
            // this.message.errorString = 'Login Failed. Please update new password and try again.';
            this.updatePassCodeNeeded = true;
          }
          this.validityStatus = 'error';
          this.message.errorString = error.error.message;
          //  this.messageService.showError(error.error.message);
          this.fpOrderApiLoading = false;
        }
      );
    }
   } else {
    this.fpOrderApiLoading = false;
   }
  }
  async updatePassword(type) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    const { PlatformLoginComponent } = await import(
      /* webpackPrefetch: true */ 'src/app/restaurant/modal/platform-login/platform-login.component'
    );
    const dialogRef = this.dialog.open(PlatformLoginComponent, {
      backdropClass: 'backdrop',
      maxHeight: '90vh',
      maxWidth: '100vw',
      data: {
        platform: this.selectedOrder,
        type: type,
        rest_id: localStorage.getItem('restaurant_id'),
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result.message === 'password_updated' && result.success === 1) {
        this.resetValues();
      }
    });
  }
  resetValues() {
    this.validityStatus = '';
    this.message = {
      errorString: '',
      validityString: '',
      successString: '',
      warningString: '',
    };
    this.updatePassCodeNeeded = false;
    this.fp_orderid = null;
  }

  createFPOrders() {
    this.autoSync = true;
    this.currentTitle = this.translationText.TITLE;
    const payload = {
      restaurant_id: localStorage.getItem('restaurant_id'),
    };
    let type;
    if (this.selectedOrder.platform === 'foodpanda') {
      type = 'fp';
    } else if (this.selectedOrder.platform === 'grab') {
      type = 'gf';
    }
    this.apiService.createFoodPandaOrders(payload, type).subscribe(
      (res: any) => {
        if (res.statusCode === 201) {
          this.messageService.showSuccess(res.data.message, 8000);
          if (res.data.unmapped_items.length)
            this.messageService.showError(res.data.unmapped_items, 6000);
          this.commonService.orderActionMessage({ action: 0 });
        } else {
          this.messageService.showError(res.data.message, 1200);
        }
      },
      (error) => {
        this.messageService.showError(error.error.message);
      }
    );
    setTimeout(() => {
      this.dialogRef.close({ data: 'closed' });
    }, 6000);
  }
  createManually() {
    if (this.currBothDLTKPlatformActive) {
      this.isPlatformMenuSync = false;
    } else {
      this.exitModal('dl', 'dl');
    }
  }
  userDetailsClicked() {
    this.customerForm.markAllAsTouched();

    if (this.customerForm.valid) {
      localStorage.setItem('pos_user_details_set', '1');
      if (
        this.selectedOrder.id === 0 &&
        this.selectedOrder.platform == 'easyeat'
      ) {
        this.modalState.showOrderType = false;
        this.modalState.showCustomer = false;
        this.modalState.showTable = true;
        this.currentTitle = this.translationText.SELECT_TABLE_NUMBER;
      } else {
        this.modalState.showOrderType = false;
        this.modalState.showCustomer = false;
        this.modalState.showTable = false;
        this.exitModal('dl', 'dl');
      }
    }
  }

  tableClicked(tableNo, tableId) {
    this.modalState.showOrderType = false;
    this.modalState.showCustomer = false;
    this.modalState.showTable = false;

    localStorage.setItem('pos_table_no_set', '1');
    this.exitModal(tableNo, tableId);
  }

  setPOSdatanExit(ot, pt, uname, tno, tid, dc, no,user_gender,user_dob) {
    this._localStorage.set('pos_order_type', ot);
    this._localStorage.set('pos_platform', pt);
    const platform = (pt || '').toLowerCase();
    const platformOt =
      platform === 'foodpanda' ||
      (platform !== 'easyeat' && this.currBothDLTKPlatformActive)
        ? 3
        : ot;
    localStorage.setItem('pos_platform_order_type', String(platformOt));
    localStorage.setItem('pos_username', uname);
    localStorage.setItem('pos_dial_code', dc);
    localStorage.setItem('pos_number', no);
    localStorage.setItem('pos_table_no', tno);
    localStorage.setItem('pos_table_id', tid);
    localStorage.setItem('user_gender', user_gender);
    localStorage.setItem('user_dob', user_dob);

    localStorage.setItem('pos_order_id', '');
    no.length > 2
      ? localStorage.setItem('pos_no_enter', '1')
      : localStorage.setItem('pos_no_enter', '0');

    this.utilService.clear_cart();
    if (this.from === 'order') {
      this.route.navigate(['/pos/order']);
    } else if (this.from === 'tables-layout') {
      this.route.navigate(['/pos/order'], {
        queryParams: { redirecturl: 'tables' },
      });
    }
  }

  get_tables() {
    this.commonService.getAllTableDataObs().subscribe((data) => {
      this.allSections = this.withoutDeletedSections(data?.all_tables?.floors);
      if (!this.allSections.length) {
        this.selectedSection = null;
        this.selectedFloorTables = [];
        return;
      }
      this.selectedSection = this.allSections[0].floor_id;
      this.findSelectedFloorTables(this.selectedSection);
    });
  }

  private withoutDeletedSections(floors: any[]): any[] {
    return (floors || [])
      .filter((floor) => Number(floor?.status) !== 9)
      .map((floor) => ({
        ...floor,
        tables: (floor?.tables || []).filter((table) => Number(table?.status) !== 9),
      }));
  }

  findSelectedFloorTables(floorid) {
    for (let item of this.allSections) {
      if (item.floor_id === floorid) {
        this.selectedFloorTables = item.tables;
        break;
      }
    }
  }
  change(id) {
    this.findSelectedFloorTables(id);
  }
  animationCreated(animationItem: AnimationItem): void {}
}
